import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "12",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill", "stroke"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.99844 1.5941C3.81862 1.41419 3.52696 1.41419 3.34715 1.5941L1.30013 3.64112L1.25885 3.6883C1.12152 3.86881 1.13521 4.12759 1.30013 4.2924L3.34715 6.33942L3.39433 6.3807C3.57484 6.51804 3.83362 6.50434 3.99843 6.33942L4.03971 6.29224C4.17705 6.11173 4.16335 5.85295 3.99843 5.68814L2.73834 4.42705L9.04623 4.42735C10.629 4.42735 11.9121 5.71045 11.9121 7.29318C11.9121 8.83824 10.6893 10.0979 9.15882 10.1567L9.04627 10.1589H6.99925C6.74487 10.1589 6.53867 10.3651 6.53867 10.6195C6.53867 10.8543 6.71439 11.0481 6.94147 11.0765L6.99924 11.0801H9.04626C11.1378 11.0801 12.8333 9.38456 12.8333 7.29306C12.8333 5.24343 11.2049 3.57414 9.17139 3.50812L9.04635 3.50612L2.73948 3.50553L3.99868 2.24533L4.03996 2.19815C4.17729 2.01764 4.1636 1.75886 3.99868 1.59405L3.99844 1.5941Z",
      fill: _ctx.fillColor,
      stroke: _ctx.strokeColor
    }, null, 8, _hoisted_2)
  ]))
}